/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PlayerPhoto } from 'widgets/brownlow-tracker/js/components/PlayerPhoto';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';

/**
 * Renders field player chips with an optional photo
 *
 * @param {object} props - The props
 * @param {object} props.player - The player object
 * @param {string} props.homeOrAway - Either 'home' or 'away'
 * @param {string} props.teamAbbr - The players team abbreviation
 * @param {boolean} props.showPhoto - Should we render a player photo?
 * @param {boolean} props.isAFLW - Whether this is an AFLW match (determines URL format for external players)
 * @param {string} props.clubId - The player's club/team ID (used to determine if player is from different club)
 * @returns {React.JSX.Element} - The rendered component
 */
export const TeamAnnouncementsFieldPlayer = ({
    player,
    homeOrAway,
    teamAbbr = '',
    showPhoto,
    isAFLW,
    clubId
}) => {
    const teamLineupsContext = useContext(TeamLineupsContext);

    return (
        <PlayerProfileLink
            key={player.playerId}
            classes="team-lineups-ins-and-outs__grid-item team-lineups-ins-and-outs__grid-item--link"
            player={{
                playerId: player?.player?.player?.playerId,
                firstName: player?.player?.player?.playerName?.givenName,
                surname: player?.player?.player?.playerName?.surname
            }}
            trackingInfo={{
                event: PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.LINK,
                component_name:
                    PULSE.app.common.CONSTANTS.TRACKING.VALUES.TEAM_LINEUPS.VIEW
                        .FIELD,
                component_content_type:
                    teamLineupsContext === 'match-centre'
                        ? PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                              .MATCH_CENTRE.LINEUPS
                        : PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                              .LINEUPS
            }}
            isAFLW={isAFLW}
            clubId={clubId}
        >
            {showPhoto ? (
                <PlayerPhoto
                    className={'team-announcements-field__player-headshot'}
                    photoUrl={player.photoURL}
                    alt={`${player?.player?.player?.playerName?.givenName} ${player?.player?.player?.playerName?.surname}`}
                />
            ) : null}
            <div className="team-announcements-field__player-tag-badge">
                <span
                    className={`team-announcements-field__player-tag-badge-number team-lineups__position-meta-label--${homeOrAway} ${teamAbbr.toLowerCase()}`}
                >
                    {player?.jumperNumber}
                </span>
                <span className="team-announcements-field__player-tag-badge-name">
                    {player?.player?.player?.playerName?.givenName.charAt(0)}
                    {'. '}
                    {player?.player?.player?.playerName?.surname}
                </span>
            </div>
        </PlayerProfileLink>
    );
};

TeamAnnouncementsFieldPlayer.propTypes = {
    player: PropTypes.object,
    homeOrAway: PropTypes.oneOf(['home', 'away']),
    teamAbbr: PropTypes.string,
    showPhoto: PropTypes.bool,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.string
};
